import React from 'react';

import {
  BarChartOutlined,
  CaretRightOutlined,
  CloseCircleOutlined,
  DashboardOutlined,
  DeleteOutlined,
  DollarOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  FileTextOutlined,
  LikeOutlined,
  MessageOutlined,
  MoreOutlined,
  PauseCircleOutlined,
  PlusCircleOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  ReloadOutlined,
  SendOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Tooltip } from 'antd';

import type { Action } from 'v2/interfaces/access-control';

const icons = {
  'abrir-chamado': QuestionCircleOutlined,
  'arquivar-produto': DeleteOutlined,
  'cadastrar-produto': PlusCircleOutlined,
  'cancelar-contrato': CloseCircleOutlined,
  'chat-vip': MessageOutlined,
  'criar-campanha': PlusCircleOutlined,
  'editar-campanha': EditOutlined,
  'editar-produto': EditOutlined,
  'entrega-manual': SendOutlined,
  'exportar-relatorio': DownloadOutlined,
  'exportar-resultado': DownloadOutlined,
  'gerenciar-cupons': TagOutlined,
  'negociar-faturas': DollarOutlined,
  'ocultar-valores': EyeInvisibleOutlined,
  'realizar-venda': ShoppingCartOutlined,
  'reativar-contrato': CaretRightOutlined,
  'solicitar-transferencia': DollarOutlined,
  'solicitar-transferência': DollarOutlined,
  'suspender-contrato': PauseCircleOutlined,
  'ver-dados-cliente': UserOutlined,
  'ver-dados-clientes': UserOutlined,
  'visualizar-indicadores': BarChartOutlined,
  'acoes': MoreOutlined,
  'adm': TeamOutlined,
  'aprovar': LikeOutlined,
  'criar': PlusCircleOutlined,
  'dashboard': DashboardOutlined,
  'detalhes': FileTextOutlined,
  'editar': EditOutlined,
  'excluir': DeleteOutlined,
  'exportar': DownloadOutlined,
  'manage': SettingOutlined,
  'reembolsar': ReloadOutlined,
  'visualizar': EyeOutlined
};

type AccessPolicyIconProps = {
  action: Action;
};

function AccessPolicyIcon({ action }: AccessPolicyIconProps) {
  const iconKey = action.fullname.split(':').pop();
  const Icon = icons[iconKey as keyof typeof icons] || QuestionOutlined;
  if (!icons[iconKey as keyof typeof icons]) console.log(iconKey);

  return (
    <Tooltip placement='top' title={action.name}>
      <span className='text-[16px]!'>
        <Icon />
      </span>
    </Tooltip>
  );
}

export { AccessPolicyIcon };
